<div class="p-p-2" style="min-width: 225px;">
	<p-checkbox name="group" [binary]="true" [label]="label|translate" [(ngModel)]="value" [disabled]="disabled">
	</p-checkbox>
</div>
